import { useState } from 'react';
import { Box, alpha } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

interface Props {
  address: string;
  height: string;
  width?: string;
  maxWidth?: string;
}

const StreetViewImage: React.FC<Props> = ({
  address,
  height,
  width = '100%',
  maxWidth = '200px',
}) => {
  // Street View requests can 403/no-image for an address the key doesn't
  // cover, which the browser renders as a broken-image box rather than
  // failing silently. Fall back to a flat placeholder instead.
  //
  // The Street View Static API caps images at 640x640 for standard API-key
  // requests; a larger size like the previous 800x400 is not guaranteed to
  // be honored. 640x400 keeps the same height as before and stays under
  // the documented cap.
  // `return_error_code=true` makes the API return a real HTTP error for
  // addresses with no imagery instead of Google's own gray placeholder
  // image, so the onError fallback below actually fires for that case.
  const [failed, setFailed] = useState(false);
  const urlAddress = encodeURIComponent(address);
  const formattedAddress = `https://maps.googleapis.com/maps/api/streetview?size=640x400&return_error_code=true&location=${urlAddress}&key=AIzaSyDIRWTPcy-0FWGza8RzhWRdSq4FK57rhKY`;

  if (failed) {
    return (
      <Box
        data-testid="street-view-fallback"
        sx={{
          height,
          width,
          maxWidth,
          margin: '0 auto',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.04),
        }}
      >
        <HomeOutlinedIcon sx={{ fontSize: 28, color: 'text.disabled' }} />
      </Box>
    );
  }

  return (
    <img
      src={formattedAddress}
      height={height}
      width={width}
      style={{
        borderRadius: 4,
        maxWidth: maxWidth,
        margin: '0 auto',
        display: 'block',
        objectFit: 'cover',
      }}
      onError={() => setFailed(true)}
    />
  );
};

export default StreetViewImage;
